import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from 'rxjs'
import { BACKEND_URI } from "../config/config-vars";
import { User } from "../models/user.model";
import { AuthorizedUser } from "../models/auth.models";

const LOGIN_URL = `${BACKEND_URI}/api/authenticate`;

const USER_SESSION_STORAGE_KEY = "authorized_user";

@Injectable({
    providedIn: "root"
})
export class LoginService {
    private __user?: AuthorizedUser;

    constructor(private http:HttpClient){}

    public async login(username: string, password: string): Promise<boolean> {
        try {
            const result: any = await firstValueFrom(this.http.post(
                LOGIN_URL, {username, password}
            ));
            
            this._user = result;
            this._user.displayName = this._user.firstName;
            this._user.profileImgUrl ='assets/images/users/avatar-9.jpg'

            return true;
        } catch(err) {
            console.error("error logging in", err);
        }
        return false;
    }
    resetPassword(value: any) {
      throw new Error('Method not implemented.');
    }
    logout() {
      this._user = null;
      // TODO - optionally contact the server to invalidate the login
    }

    public get userId() {return this._user?.id;}
    public get userType(): string {return this._user?.userType;}
    public get user(): User {
        if(this._user) {
            const current = {...this._user} as unknown;
            delete current['token'];
            return current as User;
        }
        return null;
    }
    public get isUserEnabled(): boolean {return this._user?.enabled;}
    public get isloggedIn(): boolean {return this._user!=null && this.isUserEnabled;}
    public get authToken(): string {return this._user?.token;}

    private get _user() {
        if(!this.__user) {
            const stringified_user = sessionStorage.getItem(USER_SESSION_STORAGE_KEY);
            if(stringified_user) {
                this.__user = JSON.parse(stringified_user);
            }
        }
        return this.__user;
    }

    private set _user(user: AuthorizedUser) {
        if(user){
            sessionStorage.setItem(USER_SESSION_STORAGE_KEY, JSON.stringify(user));
        } else {
            sessionStorage.removeItem(USER_SESSION_STORAGE_KEY);
        }
        this.__user = user;
    }
}